import { actions, helpers, selectors } from 'app-webtech-core';
import {
  enterFullscreen,
  toggleInfoBanner,
  ccSetSetting,
  ccNextSubmenu,
  internalResetCaptionsSettings,
} from 'app-modules/player/actions';
import { OK } from './types';

const remoteControllerOkButtonAction = helpers.actions.actionCreator(OK);

export const remoteControllerOkButtonThunkAction = () => async (dispatch, getState) => {
  await dispatch(remoteControllerOkButtonAction());
  const state = getState();
  const {
    isFullscreen: playerIsFullscreen,
    isCCMenuOpen,
    currentCCMenu,
    currentCCMenuName,
    ccMenuSelectedIndexes,
  } = selectors.player.properties(state);

  // checks to see if the cc settings menu is open
  if (!isCCMenuOpen) {
    if (!playerIsFullscreen) {
      await dispatch(actions.guide.playSelectedChannel());
      await dispatch(enterFullscreen());
    } else {
      await dispatch(toggleInfoBanner());
    }
  } else {
    const newIndex = ccMenuSelectedIndexes.concat(0);
    const menuObj = helpers.getCCMenu(
      newIndex,
      currentCCMenu,
      currentCCMenuName,
      state.playerinternal.captionsSettings.showReset,
    );
    if (menuObj.settingName !== '' && menuObj.settingValue !== '') {
      // sets the setting if the menu item is a setting
      if (menuObj.settingValue !== 'reset') {
        await dispatch(ccSetSetting(menuObj.settingName, menuObj.settingValue));
      }
    } else if (ccMenuSelectedIndexes.length > 1) {
      await dispatch(ccNextSubmenu());
    }
  }
};
